__turbopack_context__.v({
  "breadcrumbsWrapper": "N9j3Fa_breadcrumbsWrapper",
  "categoryIconWrapper": "N9j3Fa_categoryIconWrapper",
  "categorySwitchButtonActive": "N9j3Fa_categorySwitchButtonActive",
  "categorySwitchButtonWrapper": "N9j3Fa_categorySwitchButtonWrapper",
  "categorySwitchTitle": "N9j3Fa_categorySwitchTitle",
  "circularProgressWrapper": "N9j3Fa_circularProgressWrapper",
  "content": "N9j3Fa_content",
  "contentVertical": "N9j3Fa_contentVertical",
  "contentWrapper": "N9j3Fa_contentWrapper",
  "contentWrapperVertical": "N9j3Fa_contentWrapperVertical",
  "emptyStateDescription": "N9j3Fa_emptyStateDescription",
  "emptyStateTitle": "N9j3Fa_emptyStateTitle",
  "emptyStateWrapper": "N9j3Fa_emptyStateWrapper",
  "header": "N9j3Fa_header",
  "headerContent": "N9j3Fa_headerContent",
  "listingWrapper": "N9j3Fa_listingWrapper",
  "mobileCategoryNameWrapper": "N9j3Fa_mobileCategoryNameWrapper",
  "numberOfProducts": "N9j3Fa_numberOfProducts",
  "onlyWebContent": "N9j3Fa_onlyWebContent",
  "productsListWrapper": "N9j3Fa_productsListWrapper",
  "seoContainer": "N9j3Fa_seoContainer",
  "seoTitle": "N9j3Fa_seoTitle",
  "tabletContent": "N9j3Fa_tabletContent",
  "titleBanner": "N9j3Fa_titleBanner",
  "titleBannerHeading": "N9j3Fa_titleBannerHeading",
  "titleBannerProductsNumber": "N9j3Fa_titleBannerProductsNumber",
  "titleMobile": "N9j3Fa_titleMobile",
  "titleWrapper": "N9j3Fa_titleWrapper",
  "wrapper": "N9j3Fa_wrapper",
});
